import React, { useEffect } from 'react';
import {
  InstantSearch as ReactInstantSearch,
  InstantSearchProps as ReactInstantSearchProps,
  useSearchBox,
} from 'react-instantsearch-hooks';
import { searchClient } from 'algolia/searchClient';
import InsightsMiddleware from './middlewares/InsightsMiddleware';
import { usePathname, useSearchParams } from 'next/navigation';

const InstantSearch: React.FC<
  Partial<ReactInstantSearchProps & { categorySlug?: string; routing: any; insights: any }>
> = ({ indexName, children, ...props }) => {
  const { categorySlug = '', routing, insights } = props as Record<string, any>;
  const searchParams = useSearchParams();
  const pathname = usePathname();
  let searchKey = '';
  if (pathname.startsWith('/search/')) {
    const searchKeyMatch = pathname.match(/^\/search\/([^/]+)(\/|$)/);
    searchKey = searchKeyMatch ? decodeURIComponent(searchKeyMatch[1]) : '';
  }

  // const query = searchParams?.get('q') || '';
  // function UrlSearchSync() {
  //     const { refine } = useSearchBox();
  //     const path = usePathname();
  //     const query = searchParams?.get('q') || '';

  //     useEffect(() => {
  //         if (query) {
  //             refine(query);
  //         }
  //     }, [refine, query]);

  //     return null;
  // }
  return (
    <ReactInstantSearch
      searchClient={searchClient}
      indexName={indexName as string}
      routing={routing}
      insights={insights}
      {...props}
    >
      {/* <UrlSearchSync /> */}
      <InsightsMiddleware categorySlug={categorySlug} query={searchKey} />
      {children}
    </ReactInstantSearch>
  );
};

export default InstantSearch;
